export { CoviHeaderToggle } from "./components/CoviHeaderToggle"
export { SofiaHomeHeaderControls } from "./components/SofiaHomeHeaderControls"
export {
  SofiaSidebarNav,
  SOFIA_SIDEBAR_NAV_WIDTH_CLASS,
} from "./components/SofiaSidebarNav"
export { SofiaHomeThreadSwitcher } from "./components/SofiaHomeThreadSwitcher"
export { AppCoviShellRoute } from "./routes/AppCoviShellRoute"
export { useSetSofiaThreadHeaderAction } from "./hooks/useSofiaThreadHeaderAction"
export {
  useSetSofiaPanelContent,
  useSofiaPanelContent,
} from "./hooks/useSofiaPanelContent"
export { CoviComposer as SofiaComposer } from "./components/CoviComposer"
export { ChatItemView as SofiaChatMessage } from "./components/CoviPanelPresentation"
export { CoviThinkingIndicator as SofiaThinkingIndicator } from "./components/CoviThinkingIndicator"
export { SOFIA_MARKDOWN_COMPONENTS } from "./components/SofiaMarkdownLink"
export { useCoviEntityLinkPlugins } from "./hooks/useCoviEntityLinkPlugins"
export {
  buildSofiaHomeLandingPath,
  buildSofiaNotebooksPath,
  getSofiaHomeThreadId,
} from "./utils/sofiaHome"
// Notebook seam: saved chat artifacts reuse Sofia's safe presentation pieces
// instead of reaching into app-covi internals.

export { type ActionExecutionResult } from "./hooks/useActionExecutor"

// Notebook presentation of a thread, reused by the Notebooks pages.
export { NotebookCellView } from "./components/notebook/NotebookCellView"
export { projectNotebookCells, type NotebookCell } from "./utils/notebookCells"
export { useCovi } from "./contexts/CoviContext"
export { CoviVizChartBody } from "./components/CoviVizChartBody"
export { parseChartSpec } from "./utils/chartSpec"
export type { CovalChartSpecV1 } from "./model/chart/types"

export { linkifyCoviEntitiesPlugin } from "./utils/entityLinks"
export { resolveCoviEntityHref, parseCoviEntityUri } from "./utils/entityLinks"

export { SofiaMessageQueue } from "./components/SofiaMessageQueue"

export {
  SofiaTranscript,
  type SofiaTranscriptHandle,
} from "./components/SofiaTranscript"
